export default "__VITE_ASSET__BsbHB08m__"